import { io } from 'socket.io-client';

// Origine du serveur ChatchoqServer (HTTP + Socket.IO partagent le meme port).
// Resolution:
// 1) Build-time: VITE_SERVER_ORIGIN (injecte au `vite build`, ex. https://api.terraguessr.aniss.xyz)
// 2) Dev: localhost:3000
// 3) Prod sans var (deploiement same-origin): l'origine courante
const isDev = typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.DEV;
export const serverUrl = (
	typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_SERVER_ORIGIN
) || (
	isDev
		? 'http://localhost:3000'
		: (typeof window !== 'undefined' && window.location ? window.location.origin : 'http://localhost:3000')
);

function getToken() {
  try { return localStorage.getItem('tgr_token') || null; } catch { return null; }
}

export const socket = io(serverUrl, { auth: { token: getToken() } });

// Met a jour le token d'auth du socket puis reconnecte (apres login/logout).
export function setSocketAuth(token) {
  socket.auth = { token: token || null };
  try { socket.disconnect(); } catch { /* ignore */ }
  socket.connect();
}
